import DOMPurify from 'dompurify';

const EMAIL_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  's',
  'strike',
  'u',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'a',
  'span',
  'code',
  'div',
];

const EMAIL_ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i;

export function sanitizeBlockHtml(html: string): string {
  if (!html?.trim()) {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: EMAIL_ALLOWED_TAGS,
    ALLOWED_ATTR: EMAIL_ALLOWED_ATTR,
  });
}

export function plainTextToHtml(text: string): string {
  if (!text) {
    return '';
  }

  if (HTML_TAG_PATTERN.test(text)) {
    return sanitizeBlockHtml(text);
  }

  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>');
}

export function blockTextToTipTapContent(text: string, blockType: 'text' | 'title'): string {
  const inner = plainTextToHtml(text);
  if (blockType === 'title') {
    return inner ? `<h2>${inner}</h2>` : '<h2></h2>';
  }
  return inner ? `<p>${inner}</p>` : '<p></p>';
}

export function tipTapHtmlToBlockText(html: string, blockType: 'text' | 'title'): string {
  const trimmed = html?.trim();
  if (!trimmed) {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(trimmed, 'text/html');
  const expectedTag = blockType === 'title' ? 'H2' : 'P';
  const root = doc.body.firstElementChild;

  if (root?.tagName === expectedTag) {
    return sanitizeBlockHtml(root.innerHTML);
  }

  return sanitizeBlockHtml(trimmed);
}
